import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getQualifications } from "../../api/contents";
import { getFirstChar } from "../../helpers/common";

const QualificationJourney = ({
  handleOpenQualificationModal,
  componentType = "overview",
  initialData = null, // 🟢 Prop addition to directly consume Candidate profile payload data safely
}) => {
  const { candidateId } = useParams();
  const [qualifications, setQualifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 🟢 If direct initialData payload is passed down, prioritize it and skip internal fetching
    if (initialData !== null) {
      let parsedData = [];
      if (typeof initialData === "string") {
        try {
          parsedData = JSON.parse(initialData);
        } catch (e) {
          console.error(
            "Failed to parse initialData string in QualificationJourney:",
            e,
          );
          parsedData = [];
        }
      } else if (Array.isArray(initialData)) {
        parsedData = initialData;
      }

      // Sort reverse chronologically (Latest endYear at the top)
      const sorted = [...parsedData].sort(
        (a, b) =>
          (parseInt(b?.endYear || b?.additional_fields?.end_year) || 0) -
          (parseInt(a?.endYear || a?.additional_fields?.end_year) || 0),
      );
      setQualifications(sorted);
      setLoading(false);
      return;
    }

    // 🟢 FALLBACK: If no initialData prop exists, perform internal fetch tracking
    console.log(
      "🚀 UseEffect Triggered! Fetching personal qualifications via context...",
    );
    setLoading(true);

    getQualifications()
      .then((res) => {
        const dataPayload = res?.data?.data || res?.data || [];
        // Handle potential string format from API response context
        const parsedPayload =
          typeof dataPayload === "string"
            ? JSON.parse(dataPayload)
            : dataPayload;

        const sorted = [...parsedPayload].sort(
          (a, b) => (parseInt(b?.endYear) || 0) - (parseInt(a?.endYear) || 0),
        );
        setQualifications(sorted);
      })
      .catch((err) => {
        console.error(
          "Failed to load user qualifications profiles details:",
          err,
        );
      })
      .finally(() => setLoading(false));
  }, [initialData]);

  // 🟢 FIXED: Fallback safely between direct flat keys and nested additional_fields objects
  const getCollegeAndYear = (item, additionalFields) => {
    let collegeAndYear = "";

    const university =
      item?.university || additionalFields?.university_college || "";
    const start = item?.startYear || additionalFields?.start_year || "";
    const end = item?.endYear || additionalFields?.end_year || "";

    const hasYearAdded = start && end;

    if (university) {
      collegeAndYear += `${university} ${hasYearAdded ? "-" : ""} `;
    }

    if (hasYearAdded) {
      collegeAndYear += `(${start} - ${end})`;
    }

    return collegeAndYear;
  };

  // Safe character extraction helper logic
  const getFirstChar = (str) => {
    if (!str) return "E";
    return str.charAt(0).toUpperCase();
  };

  return (
    <>
      {loading ? (
        <p style={{ margin: "25px 0" }}>Loading...</p>
      ) : qualifications && qualifications?.length > 0 ? (
        qualifications?.map((item, index) => {
          const additionalFields = item?.additional_fields || {};

          // 🟢 FIXED: Prioritize new flat API properties, fallback to legacy fields
          const courseTitle =
            item?.course || additionalFields?.title || "Qualification";
          const detailsText = item?.details || additionalFields?.details || "";
          const certificationText =
            item?.certification || additionalFields?.certification || "";

          return (
            <div
              key={item?.id || index}
              className="candidate-education-content mt-4 d-flex align-items-start"
            >
              <div
                className="circle flex-shrink-0 bg-soft-primary d-flex align-items-center justify-content-center rounded-circle fw-bold text-primary fs-14"
                style={{ width: "40px", height: "40px" }}
              >
                {getFirstChar(courseTitle)}
              </div>
              <div className="ms-3 w-100">
                <div className="d-flex align-items-center justify-content-between">
                  <h6 className="fs-16 mb-1 text-dark fw-semibold">
                    {courseTitle}
                  </h6>

                  {componentType === "update" ? (
                    <div
                      className="cursor-pointer text-muted px-2"
                      onClick={() =>
                        handleOpenQualificationModal("update", item)
                      }
                    >
                      <i className="uil uil-edit"></i>
                    </div>
                  ) : null}
                </div>
                <p className="mb-2 text-muted fs-14">
                  {getCollegeAndYear(item, additionalFields)}
                </p>
                {detailsText && (
                  <p className="text-muted fs-14 mb-1">{detailsText}</p>
                )}

                {certificationText && (
                  <p className="text-muted fs-14 mb-0">
                    <b>Certification:</b> {certificationText}
                  </p>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <>
          <p className="mt-4 mb-5 text-muted fs-14 fst-italic">
            No qualification information has been added.
          </p>
        </>
      )}
    </>
  );
};

export default QualificationJourney;
